/** The signed-in user's profile page. */
export default {
  signInRequired: {
    title: "Sign in required",
    body: "Please sign in to view your profile, points and orders.",
  },
  planNames: {
    free: "Free",
    starter: "Starter",
    pro: "Pro",
    elite: "Elite",
    studio: "Studio",
  },
  planBadge: "{{plan}} plan",
  yourName: "Your name",
  upgradePlan: "Buy points",
  startGenerating: "Start generating",
  details: {
    title: "Profile details",
    fullName: "Full name",
    fullNamePlaceholder: "Your name",
    saving: "Saving…",
    save: "Save changes",
    updated: "Profile updated",
    saveFailed: "Failed to save profile",
  },
  stats: {
    credits: "Generation points",
    buyMore: "Buy more points",
    memberSince: "Member since",
  },
  plans: {
    eyebrow: "Plans",
    title: "Choose your plan",
    subtitle: "Buy another points pack whenever you need more. Every pack is a one-time payment — nothing renews automatically.",
    mostPopular: "Most popular",
  },
};
